
import React, { useState, useEffect } from 'react';
import {
  CreditCard, Users, Globe, TrendingUp,
  Award, CheckCircle, ArrowRight, Smartphone, Database, Lock, Building2,
  Wallet, FileCheck, Calculator, Shield, UserCheck,Banknote,BarChart3,
  FileText, Camera, Mail, Store, GraduationCap, Wifi, Zap, Server, Eye, Sparkles, Settings,Clock,AlertTriangle
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const PaymentSolutionsLanding = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

    const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalTitle, setModalTitle] = useState('');

  const openModal = (image, title) => {
    setModalImage(image);
    setModalTitle(title);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalImage('');
    setModalTitle('');
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);
  const offerings = [
    {
      icon: <Settings className="w-8 h-8 text-white" />,
      title: "Automated Merchant Onboarding",
      description: "Streamlined digital onboarding process with automated verification and quick setup for merchants.",
      color: "from-purple-500 to-indigo-600",
      bgColor: "bg-gradient-to-br from-purple-50 to-indigo-50"
    },
    {
      icon: <Store className="w-8 h-8 text-white" />,
      title: "Merchant Portal",
      description: "Comprehensive dashboard for merchants to manage transactions, view analytics, and access support.",
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50"
    },
    {
      icon: <Shield className="w-8 h-8 text-white" />,
      title: "Certified Payment Application",
      description: "VAPT compliant payment processing with advanced security features and fraud protection.",
      color: "from-rose-500 to-pink-600",
      bgColor: "bg-gradient-to-br from-rose-50 to-pink-50"
    },
    {
      icon: <Clock className="w-8 h-8 text-white" />,
      title: "Real-time Settlements",
      description: "Instant payment processing and settlement with real-time transaction monitoring and reporting.",
      color: "from-amber-500 to-orange-600",
      bgColor: "bg-gradient-to-br from-amber-50 to-orange-50"
    }
  ];
   const wallet = [
    {
      icon: <CreditCard className="w-12 h-12 text-white" />,
      title: "Wallet Deposit",
      description: "Seamless deposit functionality with multiple payment methods",
      color: "from-blue-500 to-cyan-600",
      bgColor: "bg-gradient-to-br from-blue-50 to-cyan-50"
    },
    {
      icon: <Banknote className="w-12 h-12 text-white" />,
      title: "Wallet Cashout",
      description: "Quick and secure withdrawal options for users",
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50"
    },
    {
      icon: <Smartphone className="w-12 h-12 text-white" />,
      title: "Wallet Operation",
      description: "Comprehensive wallet management and operations",
      color: "from-purple-500 to-indigo-600",
      bgColor: "bg-gradient-to-br from-purple-50 to-indigo-50"
    },
    {
      icon: <FileText className="w-12 h-12 text-white" />,
      title: "Wallet Report",
      description: "Detailed reporting and transaction history",
      color: "from-rose-500 to-pink-600",
      bgColor: "bg-gradient-to-br from-rose-50 to-pink-50"
    },
    {
      icon: <BarChart3 className="w-12 h-12 text-white" />,
      title: "Wallet Analytics",
      description: "Advanced analytics and insights dashboard",
      color: "from-amber-500 to-orange-600",
      bgColor: "bg-gradient-to-br from-amber-50 to-orange-50"
    },
    {
      icon: <Settings className="w-12 h-12 text-white" />,
      title: "Wallet Recon",
      description: "Automated reconciliation and balance management",
      color: "from-violet-500 to-purple-600",
      bgColor: "bg-gradient-to-br from-violet-50 to-purple-50"
    }
  ];
const services = [
    {
      id: 1,
      title: "Acquirer Management",
      description: "Connect Acquirers. Simply copy ITMs/MIDs issued by Acquirers. Turn on merchants level and sectoral level. Add new Payment Methods.",
      image: "./acquirer.png"
    },
    {
      id: 2,
      title: "TDR & MDR Management",
      description: "Setup MDR for various Payment Methods at Acquirer TID/MID level with ease. Configure TDR and Acquire MDR for Merchants at Payment Method level.",
      image: "./mdr.png"
    },
    {
      id: 3,
      title: "Split Settlements",
      description: "Split the Payment made by user. Distribute the funds received between Merchant and his Vendors/Partners/Subsidiaries.",
      image: "./split.webp"
    },
    {
      id: 4,
      title: "Fraud Checks",
      description: "A number of checks are made before transaction is flagged as probably fraudulent. Velocity Checks, Blacklist, High-value Transactions.",
      image: "./fraud.png"
    },
    {
      id: 5,
      title: "Analytics & Reporting",
      description: "Comprehensive analytics dashboard with real-time reporting. Track transaction volumes, success rates, and revenue metrics with detailed insights.",
      image: "./analytics.png"
    },
    {
      id: 6,
      title: "Security & Compliance",
      description: "Bank-grade with major security compliant. Advanced encryption, tokenization, and secure payment processing to protect sensitive data.",
      image: "./security.jpg"
    }
  ];

 
  const features = [
    { icon: Shield, text: "Level 1 Certified" },
    { icon: Lock, text: "Advanced RSA Encryption" },
    { icon: CheckCircle, text: "24/7 Security Monitoring" },
    { icon: Server, text: "Enterprise Infrastructure" }
  ];

  const verificationSteps = [
    {
      icon: FileText,
      title: "GSTN VERIFICATION",
      description: "Verify legal name of Business, Business Address with GST Network",
      color: "from-orange-400 to-red-500"
    },
    {
      icon: Camera,
      title: "ID VERIFICATION VIA SELFIE",
      description: "Verify PAN/E Image on card Issued ID with Live Selfie",
      color: "from-red-400 to-pink-500"
    },
    {
      icon: Smartphone,
      title: "MOBILE VERIFICATION",
      description: "Verify Mobile number Owner if it belongs to the Merchant via OTP",
      color: "from-purple-400 to-indigo-500"
    },
    {
      icon: Mail,
      title: "EMAIL VERIFICATION",
      description: "Verify Email address Owner if it belongs to the Merchant via OTP",
      color: "from-pink-400 to-purple-500"
    },
    {
      icon: CreditCard,
      title: "PAN VERIFICATION",
      description: "Enter PAN Number, full name, date of birth to verify if the details shared are right",
      color: "from-green-400 to-teal-500"
    },
    {
      icon: Building2,
      title: "BANK ACCOUNT VERIFICATION",
      description: "Verify if the given Bank Account Exists. Match name provided against the name registered with Bank",
      color: "from-blue-400 to-cyan-500"
    }
  ];




  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header Section */}
      <Header />  {/* SECTION 1: DARK - Hero Section */}

      
<section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-cyan-200 to-blue-300 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-purple-200 to-pink-300 rounded-full opacity-20 animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      <div className="max-w-6xl mx-auto relative">
        {/* Header */}
        <div className={`text-center mb-12 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-gray-800 via-blue-800 to-purple-800 bg-clip-text text-transparent mb-4">
          Merchant Management
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Merchant Acquiring Solutions are designed to accelerate and streamline merchant acquiring for our clients.
          </p>
        </div>

        {/* Offerings Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {offerings.map((offering, index) => (
            <div 
              key={index}
              className={`${offering.bgColor} rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-white/50 backdrop-blur-sm
                         transform hover:scale-105 hover:-translate-y-2 cursor-pointer group
                         ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
              style={{
                transitionDelay: `${index * 150}ms`
              }}
            >
              <div className="flex flex-col items-center text-center">
                <div className={`mb-6 p-4 bg-gradient-to-r ${offering.color} rounded-full shadow-lg transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                  {offering.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 group-hover:text-gray-900 transition-colors duration-300">
                  {offering.title}
                </h3>
                <p className="text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
                  {offering.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Decorative Element */}
        <div className={`flex justify-center mt-12 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '600ms'}}>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>

        {/* SECTION 3: DARK - Payment Methods */}

   <section className="relative py-16 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-blue-500/20 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-purple-500/20 rounded-full animate-bounce" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-indigo-500/20 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute bottom-32 right-1/3 w-24 h-24 bg-cyan-500/20 rounded-full animate-bounce" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-1/2 left-1/2 w-18 h-18 bg-teal-500/20 rounded-full animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <h2 className="text-4xl font-bold text-center mb-4 text-white">
          RISK MANAGEMENT
        </h2>
        <p className="text-center text-gray-300 mb-16 max-w-2xl mx-auto">
          Comprehensive risk assessment and management tools to protect your business and customers
        </p>

        {/* Timeline Style Layout */}
        <div className="max-w-4xl mx-auto">
          {/* Marker */}
          <div className="flex items-center mb-12 group">
            <div className="flex-shrink-0 w-24 h-24 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mr-8 group-hover:scale-110 transition-transform duration-300">
              <Eye className="w-12 h-12 text-white" />
            </div>
            <div className="flex-1 bg-white/5 backdrop-blur-sm p-6 rounded-r-2xl border-l-4 border-blue-500 hover:bg-white/10 transition-all duration-300">
              <h3 className="text-2xl font-bold text-white mb-2">MARKER</h3>
              <p className="text-gray-300 leading-relaxed">
                Advanced transaction monitoring system that identifies suspicious patterns and flags potential risks in real-time for immediate attention.
              </p>
            </div>
          </div>

          {/* Checker - Alternate side */}
          <div className="flex items-center mb-12 group flex-row-reverse">
            <div className="flex-shrink-0 w-24 h-24 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center ml-8 group-hover:scale-110 transition-transform duration-300">
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
            <div className="flex-1 bg-white/5 backdrop-blur-sm p-6 rounded-l-2xl border-r-4 border-orange-500 hover:bg-white/10 transition-all duration-300">
              <h3 className="text-2xl font-bold text-white mb-2 text-right">CHECKER</h3>
              <p className="text-gray-300 leading-relaxed text-right">
                Automated verification system that validates transactions, merchant credentials, and compliance requirements to ensure secure processing.
              </p>
            </div>
          </div>

          {/* Risk Checker */}
          <div className="flex items-center mb-12 group">
            <div className="flex-shrink-0 w-24 h-24 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mr-8 group-hover:scale-110 transition-transform duration-300">
              <Shield className="w-12 h-12 text-white" />
            </div>
            <div className="flex-1 bg-white/5 backdrop-blur-sm p-6 rounded-r-2xl border-l-4 border-green-500 hover:bg-white/10 transition-all duration-300">
              <h3 className="text-2xl font-bold text-white mb-2">RISK CHECKER</h3>
              <p className="text-gray-300 leading-relaxed">
                Comprehensive risk assessment engine that analyzes threat levels, calculates risk scores, and provides actionable insights for fraud prevention.
              </p>
            </div>
          </div>

         
       
        </div>
      </div>
    </section>



 <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-purple-50 to-pink-100 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-purple-200 to-pink-300 rounded-full opacity-30 animate-bounce" style={{animationDuration: '3s'}}></div>
        <div className="absolute top-1/2 -left-20 w-32 h-32 bg-gradient-to-br from-blue-200 to-cyan-300 rounded-full opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute -bottom-20 right-1/3 w-36 h-36 bg-gradient-to-br from-emerald-200 to-teal-300 rounded-full opacity-30 animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Hero Section */}
        <div className={`flex flex-col lg:flex-row items-center gap-12 mb-16 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          {/* Left Side - Illustration */}
          <div className="lg:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-80 h-96 bg-gradient-to-br from-indigo-600 to-purple-700 rounded-3xl transform rotate-6 animate-pulse shadow-2xl"></div>
              <div className="absolute top-8 left-8 w-64 h-80 bg-gradient-to-br from-gray-100 to-white rounded-2xl shadow-xl">
                <div className="p-6">
                  <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mb-4 animate-spin" style={{animationDuration: '3s'}}></div>
                  <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mb-4 animate-spin" style={{animationDuration: '3s', animationDelay: '0.5s'}}></div>
                  <div className="w-40 h-24 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg mt-8"></div>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-16 h-20 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-bounce"></div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="lg:w-1/2 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Wallet</span>{' '}
              <span className="text-gray-800">Engine</span>
            </h1>
            <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
The Wallet Engine provides apps with a fully customizable in-app wallet infrastructure, combining advanced technology with regulated e-money operations.

Our infrastructure is robust, reliable, and designed to scale. Wallet Engine is currently operational for thousands of partners, with over three million dollars transacted daily.            </p>
          </div>
        </div>

        {/* Features Header */}
        <div className={`text-center mb-12 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '300ms'}}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="text-gray-700">Unveil the features</span>{' '}
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">of</span>{' '}
            <span className="text-gray-800">Your Financial Ally</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {wallet.map((wallet, index) => (
            <div 
              key={index}
              className={`${wallet.bgColor} rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-white/50 backdrop-blur-sm
                         transform hover:scale-105 hover:-translate-y-2 cursor-pointer group
                         ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
              style={{
                transitionDelay: `${400 + index * 100}ms`
              }}
            >
              <div className="flex flex-col items-center text-center">
                <div className={`mb-6 p-4 bg-gradient-to-r ${wallet.color} rounded-2xl shadow-lg transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3`}>
                  {wallet.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 group-hover:text-gray-900 transition-colors duration-300">
                  {wallet.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm group-hover:text-gray-700 transition-colors duration-300">
                  {wallet.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Decorative Elements */}
        <div className={`flex justify-center mt-12 space-x-2 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '1000ms'}}>
          <div className="w-8 h-1 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full animate-pulse"></div>
          <div className="w-8 h-1 bg-gradient-to-r from-blue-400 to-cyan-500 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
          <div className="w-8 h-1 bg-gradient-to-r from-emerald-400 to-teal-500 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
      </div>
    </section>
       
       <section className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-20">
                  <div className="container mx-auto px-6">
          
                    {/* Merchant Verification Section */}
                    <div className="mb-32">
                      {/* Hero Header */}
                      <div className="text-center mb-16">
                        <div className="inline-flex items-center bg-gradient-to-r from-blue-600 to-purple-700 text-white px-8 py-4 rounded-full mb-8 shadow-2xl">
                          <UserCheck className="w-8 h-8 mr-4" />
                          <h2 className="text-3xl font-bold tracking-wide">MERCHANT VERIFICATION</h2>
                        </div>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                          Comprehensive verification process ensuring secure and trusted merchant onboarding
                        </p>
                      </div>
          
                      {/* Verification Flow */}
                      <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-12">
                          {verificationSteps.map((step, index) => {
                            const IconComponent = step.icon;
                            return (
                              <div key={index} className="relative group">
                                {/* Connection Line */}
                                {index < verificationSteps.length - 1 && (
                                  <div className="hidden lg:block absolute top-20 left-full w-12 h-0.5 bg-gradient-to-r from-gray-300 to-transparent z-10 transform translate-x-0 group-hover:from-blue-400"></div>
                                )}
          
                                {/* Verification Item */}
                                <div className="relative bg-white/80 backdrop-blur-sm border border-white/50 rounded-3xl p-8 hover:bg-white hover:shadow-2xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
                                  {/* Background Color on Hover */}
                                  <div className={`absolute inset-0 bg-gradient-to-r ${step.color} opacity-0 group-hover:opacity-10 rounded-3xl transition-opacity duration-500`}></div>
          
                                  {/* Icon */}
                                  <div className={`relative bg-gradient-to-r ${step.color} w-20 h-20 rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300`}>
                                    <IconComponent className="w-10 h-10 text-white" />
                                  </div>
          
                                  {/* Content */}
                                  <h3 className="relative text-lg font-bold text-gray-800 mb-4 group-hover:text-blue-700 transition-colors duration-300">
                                    {step.title}
                                  </h3>
                                  <p className="relative text-gray-600 text-sm leading-relaxed mb-4 group-hover:text-gray-700">
                                    {step.description}
                                  </p>
          
                                  {/* Status Indicator */}
                                  <div className="relative flex items-center text-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <CheckCircle className="w-4 h-4 mr-2" />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>

               
          
                  </div>
                </section>
       
   
      {/* Trusted By Section */}
      <section className="py-6 bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="w-full h-full bg-gradient-to-br from-white/5 to-transparent"></div>
        </div>

        <div className="container mx-auto px-6 relative">
          <div className="max-w-5xl mx-auto text-center">
            {/* Icon with floating animation */}
            <div className="mb-4 relative">
              <div className="bg-gradient-to-r from-yellow-400 to-orange-500 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto shadow-xl transform hover:scale-110 transition-transform duration-300">
                <Award className="w-8 h-8 text-white" />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-300 rounded-full animate-pulse"></div>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent leading-tight">
              TRUSTED BY LEADING
            </h2>
            <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
              AGGREGATORS WORLDWIDE
            </h2>

            {/* Floating elements */}
            <div className="absolute top-8 left-10 w-2 h-2 bg-blue-400 rounded-full animate-bounce"></div>
            <div className="absolute bottom-8 right-10 w-3 h-3 bg-purple-400 rounded-full animate-bounce delay-300"></div>
          </div>
        </div>
      </section>

      {/* Our Mantra Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white relative">
        <div className="container mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-semibold mb-6 shadow-lg">
              <Sparkles className="w-4 h-4 mr-2" />
              OUR PHILOSOPHY
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              OUR MANTRA
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
          </div>

          {/* Mantra Items */}
          <div className="max-w-6xl mx-auto mb-24">
            <div className="grid lg:grid-cols-3 gap-16">
              {/* Operational Excellence */}
              <div className="group text-center">
                <div className="relative mb-8">
                  <div className="bg-gradient-to-br from-blue-500 to-purple-600 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-blue-500/25 transition-all duration-500 group-hover:scale-110">
                    <CheckCircle className="w-10 h-10 text-white" />
                  </div>
                  <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                  OPERATIONAL EXCELLENCE
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Delivering consistent, high-quality performance across all our services and operations
                </p>
              </div>

              {/* Security and Reliability */}
              <div className="group text-center">
                <div className="relative mb-8">
                  <div className="bg-gradient-to-br from-green-500 to-emerald-600 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-green-500/25 transition-all duration-500 group-hover:scale-110">
                    <Shield className="w-10 h-10 text-white" />
                  </div>
                  <div className="absolute -inset-4 bg-gradient-to-r from-green-500/20 to-emerald-500/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-green-600 transition-colors duration-300">
                  SECURITY & RELIABILITY
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Maintaining the highest standards of security and reliability in every transaction
                </p>
              </div>

              {/* Continuous Improvement */}
              <div className="group text-center">
                <div className="relative mb-8">
                  <div className="bg-gradient-to-br from-purple-500 to-pink-600 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-purple-500/25 transition-all duration-500 group-hover:scale-110">
                    <TrendingUp className="w-10 h-10 text-white" />
                  </div>
                  <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-purple-600 transition-colors duration-300">
                  CONTINUOUS IMPROVEMENT
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Constantly evolving and innovating to exceed expectations and industry standards
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>   {/* Footer */}
      <Footer />
    </div>
  );
}
export default PaymentSolutionsLanding;